module.exports = __webpack_public_path__ + "static/media/health.4d1c1b72.svg";